import { render, staticRenderFns } from "./notificationType.vue?vue&type=template&id=17b7eaae&scoped=true&"
import script from "./notificationType.vue?vue&type=script&lang=js&"
export * from "./notificationType.vue?vue&type=script&lang=js&"
import style0 from "./notificationType.vue?vue&type=style&index=0&id=17b7eaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b7eaae",
  null
  
)

export default component.exports